import { IApplicationState } from '../types/redux';

export function priceRelevanceSelector(state: IApplicationState) {
  return state.newbuilding.relevanceInfo;
}
